import React from 'react';
import DialogBox from './DialogBox';

const AddDeviceDialogBox = ({
  isOpen,
  onClose,
  onSave,
  device,
  onChange,
  showDeviceId = false,
  showConnectivity = false,
  deviceTypes = [
    "Water Level",
    "AQM",
    "Treated Water",
    "LoRa Gateway",
    "Flow Meter",
    "Control Unit"
  ],
  connectivityTypes = [
    "LoRa",
    "WiFi",
    "GSM",
    "RS485",
    "Zigbee"
  ]
}) => {
  return (
    <DialogBox
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Device"
      onSave={onSave}
      saveLabel="Add Device"
      cancelLabel="Cancel"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {/* Device ID Field (optional) */}
        {showDeviceId && (
          <div>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '600',
              color: '#374151'
            }}>
              Device ID
            </label>
            <input
              type="text"
              className="dialog-input"
              value={device.device_id || ''}
              onChange={(e) => onChange({ ...device, device_id: e.target.value })}
              placeholder="Enter device ID (e.g., sensor-node-04)"
              autoFocus={showDeviceId}
            />
          </div>
        )}

        {/* Device Name Field */}
        <div>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontWeight: '600',
            color: '#374151'
          }}>
            Device Name
          </label>
          <input
            type="text"
            className="dialog-input"
            value={device.name || ''}
            onChange={(e) => onChange({ ...device, name: e.target.value })}
            placeholder="Enter device name"
            autoFocus={!showDeviceId}
          />
        </div>

        {/* Device Type Field */}
        <div>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontWeight: '600',
            color: '#374151'
          }}>
            Device Type
          </label>
          <select
            className="dialog-input"
            value={device.type || ''}
            onChange={(e) => onChange({ ...device, type: e.target.value })}
          >
            <option value="">Select device type</option>
            {deviceTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Connectivity Type Field (optional) */}
        {showConnectivity && (
          <div>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '600',
              color: '#374151'
            }}>
              Connectivity Type
            </label>
            <select
              className="dialog-input"
              value={device.connectivity || ''}
              onChange={(e) => onChange({ ...device, connectivity: e.target.value })}
            >
              <option value="">Select connectivity type</option>
              {connectivityTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </DialogBox>
  );
};

export default AddDeviceDialogBox;
